import React from "react";
import { YMaps } from '@pbe/react-yandex-maps';
import { apikey, } from "./utils/consts";
import ContainerInputsForm from "./components/Form/FormSettings";
// import imgBusStop from '@images/busStopInCircle.png';
import YMap from "./components/YMap/YMap";
import SlideMapMenu from "./components/SlideMenu/SlideMenu";
import ToastMap from "./components/Toasts/Toast";
import useInitMap from "./hooks/useInitMap";
import { useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import useMode from "./hooks/useMode";
import useStationsMod from "./hooks/useStationsMode";
import useRoadmapsMode from "./hooks/useHandleDataForm";
import ShowRoadmapInfo from "./components/Form/ShowRoadmapInfo";
import InfoInitModal from "./components/ModalsAndForms/InfoModalsInitApp";
import styled from "styled-components";
import pkg from '../../../package.json';

const appVersion = pkg.version;

const MapScreen = () => {
    const mode = useSelector((state: RootState) => state.mapScreen.mapMode);
    const roadmaps = useSelector((state: RootState) => state.mapScreen.roadmaps);
    useStationsMod();
    useRoadmapsMode()
    const [isInfoInitModal, setIsInfoInitModal] = React.useState<boolean>(true);
    useInitMap();
    useMode()

    return (
        <>
            <InfoInitModal isOpen={mode !== 'query' && isInfoInitModal} onClose={() => setIsInfoInitModal(false)} />
            <YMaps query={{
                apikey,
                ns: "use-load-option",
                load: "templateLayoutFactory,layout.ImageWithContent",
            }}>
                <div className="map-screen__map-container">
                    <YMap />
                    {mode !== 'query' &&
                        <ContainerInputsForm />}
                    {mode === 'query' && roadmaps.length > 0 &&
                        <ShowRoadmapInfo />}
                    <SlideMapMenu />
                    <ToastMap />
                     <VersionLabel>{`v${appVersion}`}</VersionLabel>
                </div>
            </YMaps>
        </>
    )
}

export default MapScreen;

const VersionLabel = styled.div`
    position: absolute;
    bottom: 20px;
    right: 6px;
    font-size: 10px;
    color: #5c5c5cd3;
    background: rgba(255, 255, 255, 0.7);
    padding: 2px 4px;
    border-radius: 4px;
    user-select: none;
`;